module.exports = __webpack_public_path__ + "static/media/36.1198b1e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/36.jpg
// module id = 726
// module chunks = 0